'use client';
import cn from 'classnames';
import { Column, Container, Row, YouTubeVideo } from 'components/ui-kit';
import Link from 'next/link';
import React, { memo } from 'react';
import { Slider } from './components';
import styles from './dva-myacha-peppershtein-page.module.scss';

export const DvaMyachaPeppershteinPage = memo(
  function DvaMyachaPeppershteinPage() {
    return (
      <div className={styles.collaborationPage}>
        <section className={styles.hero}>
          <img
            className={styles.heroBanner}
            src="/images/collaborations/dva-myacha-peppershtein/banner.jpeg"
            alt="banner"
          />
          <div className={styles.heroText}>
            <h1 className={styles.heroTitle}>
              ТОЧКА &times; ДВА МЯЧА &times; ПЕППЕРШТЕЙН
            </h1>
            <p className={styles.heroSubtitle}>
              Кеды для&nbsp;тех, кто всегда в&nbsp;движении
            </p>
          </div>
          <div className={styles.nextScreen}>
            <div className={styles.nextScreenContent}>
              <span className={styles.nextScreenText}>Узнать больше</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="36"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.5.5a.5.5 0 0 0-1 0v34.018l-4.706-3.422a.5.5 0 0 0-.588.808l5.5 4a.5.5 0 0 0 .588 0l5.5-4a.5.5 0 1 0-.588-.808L8.5 34.518V.5z"
                  fill="#000"
                />
              </svg>
            </div>
          </div>
        </section>
        <section className={styles.main}>
          <Container className={styles.mainSection}>
            <p className={styles.mainLargeText}>
              С&nbsp;самого начала Универмаг создавался Точкой, как магазин
              для&nbsp;предприимчивых людей, меняющих мир вокруг. Честность,
              созидание, неравнодушие и&nbsp;энтузиазм в&nbsp;их&nbsp;характере
              соседствуют с&nbsp;бунтарским духом, смелостью, простотой
              и&nbsp;свободой.
            </p>
            <br />
            <p className={styles.mainLargeText}>
              Для&nbsp;создания новых вещей мы&nbsp;находим людей и&nbsp;бренды
              со&nbsp;схожими ценностями. Когда мы&nbsp;встречаем
              единомышленников, мы&nbsp;создаем что-то особенное.
            </p>
          </Container>
          <Container className={styles.mainSection}>
            <h2 className={styles.mainHeader}>
              <mark>Новая коллаборация</mark>&nbsp;&mdash; идеальное сочетание
              команды и&nbsp;смыслов
            </h2>
            <Row className={styles.rowWithUzor}>
              <img
                className={styles.uzorDesktop}
                src="/images/collaborations/dva-myacha-peppershtein/uzor1.png"
                alt="Узор"
              />
              <Column span={{ s: 12, m: 6 }}>
                <p className={styles.mainText}>
                  Павел Пепперштейн&nbsp;&mdash; художник и&nbsp;писатель,
                  создатель и&nbsp;идеолог течения &laquo;психоделический
                  реализм&raquo;. Один из&nbsp;самых известных российских
                  художников на&nbsp;современном рынке искусства. В&nbsp;его
                  работах зрителю открываются загадочные гибридные миры,
                  соединяющие мотивы русской и&nbsp;античной мифологии,
                  смешиваются узнаваемые культурные образы и&nbsp;остроумные
                  комментарии.
                </p>
              </Column>
              <Column span={{ s: 12, m: 6 }}>
                <figure>
                  <img
                    className={styles.img}
                    src="/images/collaborations/dva-myacha-peppershtein/peppershtein.jpeg"
                    alt="Павел Пепперштейн"
                  />
                  <figcaption>Фотограф: Алексей Дунаев</figcaption>
                </figure>
              </Column>
            </Row>
            <Row className={styles.rowDesktopReverse}>
              <Column span={{ s: 12, m: 6 }}>
                <p className={styles.mainText}>
                  Два мяча&nbsp;&mdash; российский бренд, воссоздающий
                  оригинальные кеды середины XX&nbsp;века. Ребята ценят
                  и&nbsp;уважают наше наследие, сохраняют самобытность
                  и&nbsp;остаются верны себе и&nbsp;своей аудитории.
                  В&nbsp;коллаборации использовали легендарную модель кед,
                  история которых длится с&nbsp;1965&nbsp;года.
                </p>
              </Column>
              <Column span={{ s: 12, m: 6 }}>
                <img
                  className={styles.img}
                  src="/images/collaborations/dva-myacha-peppershtein/dva-myacha.png"
                  alt="Два мяча"
                />
              </Column>
            </Row>
          </Container>
          <Container className={styles.mainSection}>
            <h3 className={cn(styles.mainHeader, styles.apocFont)}>
              <mark className={styles.fontItalic}>
                Кеды 1965&nbsp;&mdash;
                <br className={styles['d-m-block']} /> Точка &times; Два мяча
                &times; Пепперштейн
              </mark>
              <br />
              для тех, кто всегда в&nbsp;движении, что&nbsp;бы
              <br />
              ни&nbsp;происходило вокруг
            </h3>
            <div className={styles.mainVideoContainer}>
              <YouTubeVideo
                buttonImg="/images/collaborations/beat/play.png"
                link="https://www.youtube.com/embed/jL8hvlN9qK4"
                title="Точка X 2 мяча X Пепперштейн"
                posterImg="/images/collaborations/dva-myacha-peppershtein/poster.jpeg"
                altForPosterImg="Точка X 2 мяча X Пепперштейн видео"
              />
            </div>
          </Container>
          <Container className={styles.mainSection}>
            <Row className={styles.rowDesktopReverse}>
              <Column span={{ s: 12, m: 6 }}>
                <h3
                  className={cn(
                    styles.mainHeader,
                    styles.desktopTextLeftAlign,
                    styles.apocFont,
                  )}
                >
                  <img
                    className={styles.uzorMobile}
                    src="/images/collaborations/dva-myacha-peppershtein/uzor-mob.png"
                    alt="Узор"
                  />
                  <mark className={styles.fontItalic}>Павел Пепперштейн</mark>{' '}
                  <br />
                  о&nbsp;рисунке на&nbsp;кедах
                </h3>
                <p className={styles.mainText}>
                  Обувь является важнейшим посредником между телом человека
                  и&nbsp;телом нашей планеты Земли. Одновременно обувь
                  представляет собой социальное послание. Будучи напрямую
                  связанной с&nbsp;движением, обувь многое говорит о&nbsp;том,
                  как человек хочет перемещаться по&nbsp;поверхности планеты
                  и&nbsp;куда он&nbsp;устремлён. Наша планета представляет собой
                  одно из&nbsp;космических тел. Её&nbsp;можно даже назвать
                  космическим кораблём, на&nbsp;котором мы&nbsp;все путешествуем
                  в&nbsp;безграничном пространстве.
                </p>
              </Column>
              <Column span={{ s: 12, m: 6 }}>
                <div className={styles.mainImagesSlider}>
                  <Slider />
                </div>
              </Column>
            </Row>
            <Row>
              <Column span={{ s: 12, m: 8 }}>
                <p className={styles.mainText}>
                  Поэтому обувь&nbsp;&mdash; это клапан, позволяющий нам,
                  пассажирам космического корабля, нажимать на&nbsp;нужные точки
                  и&nbsp;существенные кнопки на&nbsp;пульте управления нашей
                  орбитальной станции и&nbsp;ощущать ответные импульсы,
                  проникающие сквозь подошву и&nbsp;достигающие нашего сознания.
                </p>
              </Column>
            </Row>
          </Container>
          <Container className={styles.mainSection}>
            <Row className={styles.mainProductImages}>
              <Column span={{ s: 12, m: 4 }}>
                <img
                  className={styles.img}
                  src="/images/collaborations/dva-myacha-peppershtein/dva-myacha-image-1.jpg"
                  alt="Кеды 1965 – Точка × Два мяча × Пепперштейн"
                />
              </Column>
              <Column span={{ s: 12, m: 4 }}>
                <img
                  className={styles.img}
                  src="/images/collaborations/dva-myacha-peppershtein/dva-myacha-image-2.jpg"
                  alt="Кеды 1965 – Точка × Два мяча × Пепперштейн"
                />
              </Column>
              <Column span={{ s: 12, m: 4 }}>
                <img
                  className={styles.img}
                  src="/images/collaborations/dva-myacha-peppershtein/dva-myacha-image-3.jpg"
                  alt="Кеды 1965 – Точка × Два мяча × Пепперштейн"
                />
              </Column>
            </Row>
            <div className={styles.mainProductInfo}>
              <p className={cn(styles.mainText, styles.mainTextCentered)}>
                <strong>
                  Кеды 1965&nbsp;&mdash; Точка &times; Два мяча &times;
                  Пепперштейн
                </strong>
              </p>
            </div>
            <Row>
              <Column span={{ s: 10, m: 8 }} offset={{ s: 1, m: 2 }}>
                <Link href="/product/kedy-1965-tochka-h-dva-myacha-h-peppershtejn/">
                  <button className={styles.mainProductBuyButton} type="button">
                    Купить
                  </button>
                </Link>
              </Column>
            </Row>
          </Container>
        </section>
      </div>
    );
  },
);
